import { Component } from "@angular/core";

@Component({
  selector: "app-general-tax-advisor-rules",
  templateUrl: "./general-tax-advisor-rules.component.html",
  styleUrls: ["./general-tax-advisor-rules.component.scss"],
  standalone: false
})
export class GeneralTaxAdvisorRulesComponent {}
